import { z } from 'zod';

/** Hector interactive selection budgets, not Google API quotas. No silent truncation. */
export const GMAIL_SELECTION_MAX_THREADS = 20;
export const GMAIL_SELECTION_MAX_MESSAGES = 100;
/** Accept only API hexadecimal IDs; UI/sync thread IDs must be resolved by the host first. */
export const GmailSelectionIdSchema = z.string().min(1).max(128).regex(/^[0-9a-f]+$/);

export const GmailSelectionBodySchema = z.object({
  threadIds: z.array(GmailSelectionIdSchema).min(1).max(GMAIL_SELECTION_MAX_THREADS)
    .refine((ids) => new Set(ids).size === ids.length, 'La sélection Gmail doit contenir des identifiants de fils uniques.'),
}).strict();
export type GmailSelectionBody = z.infer<typeof GmailSelectionBodySchema>;

export const GmailSelectedMessageSchema = z.object({
  itemId: GmailSelectionIdSchema,
  subject: z.string(),
  conversationId: GmailSelectionIdSchema,
  hasAttachment: z.boolean(),
  itemMode: z.enum(['read', 'compose']),
}).strict();
export type GmailSelectedMessage = z.infer<typeof GmailSelectedMessageSchema>;

/** A Gmail row selects a thread; messages are the explicit expansion of those threads. */
export const GmailSelectionResponseSchema = z.object({
  threadCount: z.number().int().min(1).max(GMAIL_SELECTION_MAX_THREADS),
  messages: z.array(GmailSelectedMessageSchema).min(1).max(GMAIL_SELECTION_MAX_MESSAGES),
}).strict().superRefine((value, ctx) => {
  if (new Set(value.messages.map((message) => message.itemId)).size !== value.messages.length) {
    ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['messages'], message: 'Les messages Gmail résolus doivent être uniques.' });
  }
  if (new Set(value.messages.map((message) => message.conversationId)).size !== value.threadCount) {
    ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['threadCount'], message: 'Chaque fil Gmail sélectionné doit être représenté dans la réponse complète.' });
  }
});
export type GmailSelectionResponse = z.infer<typeof GmailSelectionResponseSchema>;
